/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Test_Phone_Not_AllowedInputs */

const vi_error_zns_test_phone_not_allowed = /** @type {(inputs: Error_Zns_Test_Phone_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số này chưa có trong danh sách số gửi thử — thêm ở tab Kết nối.`)
};

/**

* @param {Error_Zns_Test_Phone_Not_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_test_phone_not_allowed = /** @type {((inputs?: Error_Zns_Test_Phone_Not_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Test_Phone_Not_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_test_phone_not_allowed(inputs)
});